module.exports = function() {
  return new Worker(__webpack_public_path__ + "557ccc3517a6a6d6a5ea.worker.js");
};